<template>
  <div>

    <div v-if="debug_show_page_name==true" style="color:green;">log-history-modal</div>
    <modal class="change_history-modal" width="95%" height="90%"  content_height="90%" body_height="85%" :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <!-- <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><strong>アップグレード元の証書を選択</strong></center>
        </h4>
      </div> -->
      <div  class="modal-body change_history-modal-body " style="height: 95%;padding: 0px 15px; overflow-x: auto;" >

      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_software_linked_upgrade</div>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="アップグレード元の証書を選択"></title-and-search>
          <search-control
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
        </div>

      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <div style="float:left">
        </div>
        <button type="button" class="btn btn-default " @click="closed('no')">戻る</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus';
import { utils } from '@/libs/utils';
var vm = this;

import modal from './local-modal';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_certificate_software';
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";


Vue.component('modal', modal);
import _ from 'lodash';
import debug from 'debug';
import constants from '../../rules/constants';
var debug_log_history = debug('esma:change_history');
export default {
   mixins:[
        mixinPageCommon,mixinDatasource
  ],
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      show_modal: false,
      selected_data :false,
      row_data:[],
      api_name:"certificate_software",
      search_timeout : false,
      search_model:"",
      show_details:false,
      data_changes:[],
      show_details_label:"選択",

      state_current_editing:"current_editing3",
      state_current_row:"current_row3",
      state_is_editing_new:"is_editing_new3",
      state_last_filter_options:"last_filter_options3",
    };
  },
  computed: {
    showModal() {
      return this.show_modal;
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.status, {}),
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.certificate_software_number, {tab_label:"証書管理番号",tab_size:60}),
        utils.extend(fields.company, {}),
        utils.extend(fields.licensed_department, {}),
        utils.extend(fields.license_jurisdiction_team, {}),
        utils.extend(fields.jurisdiction_classification, {}),
        utils.extend(fields.license_jurisdiction_system, {}),
        utils.extend(fields.license_name, {}),
        utils.extend(fields.effective_number, {}),
        utils.extend(fields.remaining_number, {}),
        utils.extend(fields.expiration_date, {type:filed_types.DATE_PICKER}),
        utils.extend(fields.maintenance_deadline, {type:filed_types.DATE_PICKER}),
      ];
    }
  },
  methods: {
      onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      this.$emit("selected",data);
      setTimeout(() => {
        this.show_modal = false;
      }, 100);
      // return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:false})
    },
    onShow(data) {
      this.api_request_options = {filter_mode:"select_for_upgrade"};
      this.emulateSearchControlChangedDatasource(true)
      this.$notify({clean: true});
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },500)
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },1000)
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },3000)
    },
    showModalWindow(data) {
      debug_log_history("showModalWindow");
      this.onShow(data);
      this.show_modal = true;
    },
    closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    },
  },
   beforeMount() {
    this.count_from_result = true;
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource({load_only_with_filter:true});
  },
  mounted() {
    debug_log_history('On mounted');
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
  props: {
    tag: { type: String, default: 'showCertificateSoftwareLinkedUpgradeModal' },
  },
};

</script>
<style scoped>

.info_div {
  width: 32%;
  float: left;
}
.hist_td {
  border:1px solid #ccc;
  padding:2px 10px;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// certificate-software-linked-upgrade-modal.vue?7930ea47